import { OFFER_PARAM } from '../ProductVariants/constants';

const DEFAULT_PARAM_NAME = OFFER_PARAM;
const DEFAULT_SELECTOR = '.content-group-tabs';
// Parameter names editors may set: letters, numbers, "-" and "_"
const PARAM_NAME_PATTERN = /^[A-Za-z0-9_-]+$/;
// How long to wait after the last DOM change before updating links again
const MUTATION_DEBOUNCE_MS = 50;
// Blaze pages route through the /Resolver Next.js page, as Blaze's Link does
const RESOLVER_PAGE = '/Resolver';

export {
  DEFAULT_PARAM_NAME,
  DEFAULT_SELECTOR,
  PARAM_NAME_PATTERN,
  MUTATION_DEBOUNCE_MS,
  RESOLVER_PAGE
};
